import { country_codes as _country_codes } from "features/Common/modules/Phone/constants/CountryCodes.constants";

const country_codes = Object.values(_country_codes);

export default country_codes;
